import React, { useEffect, useContext, useState } from 'react';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { clientMenu, clientMenuWithoutDoc, adminMenu } from '../../../menu';
import ConfigContext from '../../../contexts/configContext';

import ThemeContext from '../../../contexts/themeContext';
import AuthContext from '../../../contexts/authContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import GetPermissions from './adminfilter';
type MenuItem = {
	id: string;
	text: string;
	path: string;
	icon?: string;
	hide?: boolean;
	subMenu?: Record<string, MenuItem>;
};
const DefaultAside = () => {
	const { asideStatus, setAsideStatus, documentPageStatus } = useContext(ThemeContext);
	const { publicSettings } = useContext(ConfigContext);

	const { userData, dealerPermissions } = useContext(AuthContext);

	const [isRootUser, setIsRootUser] = useState(true)
	useEffect(() => {
    const rootDealerUsername: string | undefined = Array.isArray(publicSettings)
      ? (publicSettings as any[]).find((item) => item.key === 'rootDealerUsername')?.value
      : undefined;
	setIsRootUser(rootDealerUsername?.toLowerCase() === userData.userName?.toLowerCase());
  }, [publicSettings, ]);
	// Conditionally filter the menu items based on separate boolean conditions
	function getFilteredClientMenu(userData: any) {
		const { enableCashDelivery, enableDepositRequest, creditLoanPercentage } = userData;

		const filteredMenu: any = {};
		filteredMenu.dashboard = clientMenu.dashboard;
		filteredMenu.history = clientMenu.history;
		filteredMenu.analysis = clientMenu.analysis;
		filteredMenu.platforms = clientMenu.platforms;
		filteredMenu.marginCalculator = clientMenu.marginCalculator;
		filteredMenu.mail = clientMenu.mail;
		filteredMenu.educationcenter = clientMenu.educationcenter;

		if (
			enableCashDelivery !== undefined &&
			enableCashDelivery
		) {
			filteredMenu.withdraw = clientMenu.withdraw;
		}

		if (creditLoanPercentage !== undefined && creditLoanPercentage !== 0) {
			filteredMenu.loan = clientMenu.loan;
		}
		if (
			enableDepositRequest !== undefined &&
			enableDepositRequest 
		) {
			filteredMenu.deposit = clientMenu.deposit;
		}

		return { ...filteredMenu };
	}

	const filterAdminMenu = (
		menu: Record<string, MenuItem>,
		condition: Record<string, boolean>,
	): Record<string, MenuItem> => {
		const filteredMenu: Record<string, MenuItem> = {};

		Object.entries(menu).forEach(([key, value]) => {
			const { id, text, path, icon, hide, subMenu } = value;

			// Check if the condition applies to the current item or its submenu
			if (condition[value.id]) {
				const filteredSubMenu = subMenu ? filterAdminMenu(subMenu, condition) : undefined;

				filteredMenu[key] = {
					id,
					text,
					path,
					icon,
					hide,
					subMenu: filteredSubMenu,
				};
			}
		});

		return filteredMenu;
	};
	const filteredMenu = getFilteredClientMenu(userData);
	const condition = GetPermissions(dealerPermissions,isRootUser);
	const filteredAdminMenu = filterAdminMenu(adminMenu, condition);
	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				{userData.userTypeId === 3 ? (
					<Navigation menu={filteredAdminMenu} id='aside-dashboard' />
				) : (
					<Navigation
						menu={documentPageStatus ? filteredMenu : clientMenuWithoutDoc}
						id='aside-dashboard'
					/>
				)}
				<NavigationLine />
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
